import $ from 'jquery';
import { Image, Tile } from "ol/layer";
import ImageArcGISRest from "ol/source/ImageArcGISRest";
import TileArcGISRest from "ol/source/TileArcGISRest";
import { Switchboard } from "../../../lib/events";
import { ServerLayer } from "../../../lib/layers/server/ServerLayer";
import { None, Some } from "../../../lib/misc/option";
import { ParameterUpdater } from "./thematicdata/ParameterUpdater";
import { ThematicBoxEntry } from "./thematicui/ThematicBoxEntry";
import { ThematicLegend } from "./thematicui/ThematicLegend";
export class ThematicLayer extends ServerLayer {
    constructor(opts) {
        super(opts);
        this.legend_ui = $();
        this.group_layers = [];
        this.field = '';
        this.param_updater = None.instance();
        this.broadcaster = Switchboard.get_emitter('THEMATIC');
        this.receiver = Switchboard.get_receiver('THEMATIC');
        this.legend_box = $('#thematicbox');
        this.parsed_opacity = 0;
        this.layerbox_entry = new ThematicBoxEntry(this.layer_id, opts.name, opts.visible);
        this.parsed_opacity = typeof opts.opacity === 'number' ? opts.opacity : 0.7;
        this.layerbox_entry.$input.on('click', (e) => this.input_click_handler(e));
        const interactive = typeof opts.group_field === 'string' && opts.group_field !== '';
        this.legend_entry = new ThematicLegend(opts.name, interactive, opts.group_layers);
        this.legend_entry.buckets.forEach(bucket => {
            bucket.label_ui.on('click', () => {
                this.param_updater.map(u => {
                    u.toggle_bucket(bucket.name);
                    bucket.toggle();
                    if (this.legend_entry.active_buckets.length === 0)
                        this.raw.map(l => l.setVisible(false));
                    else
                        this.raw.map(l => l.setVisible(true));
                });
            });
            bucket.label_ui.on('contextmenu', () => {
                this.param_updater.map(u => {
                    const actives = this.legend_entry.active_buckets;
                    if (actives.length === 1 && actives[0].name === bucket.name) {
                        this.legend_entry.all_on();
                        u.all_on();
                        return;
                    }
                    this.legend_entry.all_off();
                    u.clear();
                    bucket.on();
                    u.toggle_bucket(bucket.name, true);
                    if (actives.length === 0)
                        this.raw.map(l => l.setVisible(false));
                    else
                        this.raw.map(l => l.setVisible(true));
                });
            });
        });
        this.receiver.on('thematic_select', (name) => {
            this.visible = this.name === name;
            this.opacity = this.parsed_opacity;
            this.ui.map(ui_elem => {
                ui_elem.find('input:radio').prop('checked', this.name === name);
            });
        });
    }
    get layers() {
        return this.raw.map(l => [l]).unwrapOr([]);
    }
    input_click_handler(e) {
        if (this.visible) {
            e.target.checked = false;
        }
        this.visible = e.target.checked;
        if (this.visible)
            this.broadcast();
        if (this.should_show_legend()) {
            this.legend_box.removeClass('hidden');
        }
        else {
            this.legend_box.addClass('hidden');
        }
    }
    is_type_one(opts) {
        let result = typeof opts.infoUrl === 'string';
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        return result;
    }
    is_type_two(opts) {
        let result = typeof opts.infoUrl === 'string';
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        result && (result = typeof opts.group_visible === 'boolean' && Array.isArray(opts.group_layers));
        return result;
    }
    is_type_three(opts) {
        let result = typeof opts.infoUrl === 'string';
        result && (result = Array.isArray(opts.exportUrl) && opts.exportUrl.every(u => typeof u === 'string'));
        result && (result = typeof opts.isBaseLayer === 'boolean' && typeof opts.visible === 'boolean');
        result && (result = typeof opts.group_visible === 'boolean' && typeof opts.group_field === 'string' && typeof opts.group_as_label === 'boolean' && Array.isArray(opts.group_layers));
        return result;
    }
    validate(opts) {
        return [this.is_type_one, this.is_type_two, this.is_type_three].some(v => v(opts));
    }
    make_simple_tile(opts, api) {
        this.projection = api.projection;
        return new Tile({
            visible: opts.visible,
            source: new TileArcGISRest({
                projection: api.projection,
                params: opts.details,
                urls: opts.exportUrl,
                crossOrigin: 'anonymous',
                wrapX: false,
                hidpi: false,
                transition: 0
            })
        });
    }
    make_complex(opts, api) {
        this.projection = api.projection;
        const layerInfo = "show:" + opts.group_layers.filter(l => !!l.id).map((l) => l.id).join();
        const defs = "{" + opts.group_layers.filter(l => !!l.id).map(l => '"' + l.id + '":"' + l.definition).join('",') + '"}';
        const options = { ...opts.details, layers: layerInfo, layerDefs: defs };
        if (!opts.group_as_label) {
            return new Tile({
                visible: opts.group_visible,
                source: new TileArcGISRest({
                    params: options,
                    urls: opts.exportUrl,
                    crossOrigin: 'anonymous',
                    wrapX: false,
                    hidpi: false,
                    projection: api.projection,
                    transition: 0
                })
            });
        }
        return new Image({
            visible: opts.group_visible,
            opacity: opts.opacity,
            source: new ImageArcGISRest({
                url: opts.exportUrl[0],
                params: options,
                crossOrigin: 'anonymous',
                hidpi: false,
                projection: api.projection
            })
        });
    }
    async parse_config(opts) {
        this.name = opts.name;
        const api = await this.get_service_api([opts.infoUrl]);
        if (!api)
            return;
        if (api.token) {
            opts.details = {
                ...opts.details,
                token: api.token
            };
        }
        if (this.is_type_two(opts) || this.is_type_three(opts)) {
            this.raw = new Some(this.make_complex(opts, api));
            this.raw.map(l => l.setOpacity(this.parsed_opacity));
            this.group_layers = opts.group_layers;
            if (opts.group_field) {
                this.field = opts.group_field;
                this.param_updater = ParameterUpdater.create(this);
            }
            return;
        }
        this.raw = new Some(this.make_simple_tile(opts, api));
        this.raw.map(l => l.setOpacity(this.parsed_opacity));
    }
    get visible() {
        return this.raw.map(l => l.getVisible()).unwrapOr(false);
    }
    set visible(val) {
        if (val === this.visible)
            return;
        this.raw.map(l => l.setVisible(val));
        this.ui.map(u => u.toggleClass('active', val));
        this.legend_ui.toggleClass('hidden', !val);
        this.legend_ui.toggleClass('active', val);
    }
    should_show_legend() {
        return this.visible;
    }
    broadcast() {
        this.broadcaster.emit('thematic_select', this.name);
    }
    create_ui() {
        this.ui = new Some(this.layerbox_entry.repr);
        this.create_legend_ui();
    }
    create_legend_ui() {
        if (this.loaded)
            return;
        this.legend_ui = this.legend_entry.repr;
        if (this.visible)
            this.legend_ui.removeClass('hidden');
        this.loaded = true;
    }
}
